module.exports = __webpack_public_path__ + "static/media/joins.fdd660ef.png";